var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    [
      _c("header", [
        _vm.isUserInfo ? _c("h1", [_vm._v("会員情報変更")]) : _vm._e(),
        _vm._v(" "),
        _vm.isFavoriteClub
          ? _c("h1", [_vm._v("お気に入りクラブ・メール設定")])
          : _vm._e(),
        _vm._v(" "),
        _vm.isOneTouchPass && !_vm.isAddOneTouchPass
          ? _c("h1", [_vm._v("登録済みワンタッチパスID")])
          : _vm._e(),
        _vm._v(" "),
        _vm.isOneTouchPass && _vm.isAddOneTouchPass
          ? _c("h1", [_vm._v("ワンタッチパスID情報登録")])
          : _vm._e(),
        _vm._v(" "),
        _vm.isEmailSetting ? _c("h1", [_vm._v("メール設定")]) : _vm._e(),
      ]),
      _vm._v(" "),
      _vm._t("errors"),
      _vm._v(" "),
      _vm.showLoading
        ? _c("div", { staticClass: "jleague_loader" })
        : _c(
            "div",
            [
              !_vm.isChanged
                ? [
                    _vm.isPasswordPage
                      ? _c("password-confirm", {
                          attrs: {
                            "data-csrf-name": _vm.dataCsrfName,
                            "data-csrf": _vm.dataCsrf,
                            params: _vm.urlParams,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "note",
                                fn: function () {
                                  return [
                                    _c("p", [
                                      _vm._v(
                                        "登録した会員情報を変更するにあたり、ＪリーグID登録時に設定したパスワードを入力してください。"
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "recovery-note",
                                fn: function () {
                                  return [_vm._t("recovery-request")]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : [
                          _vm.isUserInfo
                            ? _c("user-info", {
                                attrs: {
                                  "data-csrf-name": _vm.dataCsrfName,
                                  "data-csrf": _vm.dataCsrf,
                                  "data-token": _vm.dataToken,
                                  userinfo: _vm.userinfo,
                                },
                                on: { "alert-message": _vm.alertMessage },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isFavoriteClub
                            ? _c("favorite-club", {
                                attrs: {
                                  "data-csrf-name": _vm.dataCsrfName,
                                  "data-csrf": _vm.dataCsrf,
                                  "data-token": _vm.dataToken,
                                  userinfo: _vm.userinfo,
                                },
                                on: { "alert-message": _vm.alertMessage },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isOneTouchPass
                            ? _c("one-touch", {
                                attrs: {
                                  "data-csrf-name": _vm.dataCsrfName,
                                  "data-csrf": _vm.dataCsrf,
                                  "data-token": _vm.dataToken,
                                  userinfo: _vm.userinfo,
                                },
                                on: {
                                  "add-one-touch-pass": _vm.addOneTouchPass,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "note",
                                      fn: function () {
                                        return [
                                          _c("p", [
                                            _vm._v(
                                              "ワンタッチパス対象となっているクラブ会員情報を登録することでJ リーグチケットなどファンクラブ割引などのサービスをご利用いただくことが可能です。"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              "お手持ちのワンタッチパスID（クラブ発行会員番号）およびパスワードを入力し、ワンタッチパス対象の会員情報を登録してください。"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "linkMark",
                                                attrs: {
                                                  target: "_blank",
                                                  href: "https://www.jleague-ticket.jp/guide/ticket_limited",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "J リーグチケットでの会員限定発売について"
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  4239317847
                                ),
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isEmailSetting
                            ? _c("email-setting", {
                                attrs: {
                                  "data-csrf-name": _vm.dataCsrfName,
                                  "data-csrf": _vm.dataCsrf,
                                  "data-token": _vm.dataToken,
                                  userinfo: _vm.userinfo,
                                },
                              })
                            : _vm._e(),
                        ],
                  ]
                : _c(
                    "div",
                    { staticClass: "regist" },
                    [
                      _c("div", { staticClass: "msg" }, [
                        _vm.isUserInfo
                          ? _c("p", [
                              _vm._v(
                                "\n                    会員情報の変更が完了しました。\n                "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isFavoriteClub
                          ? _c("p", [
                              _vm._v(
                                "\n                    お気に入りクラブ・メール設定"
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                    が完了しました。\n                "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isOneTouchPass
                          ? _c("p", [
                              _vm._v(
                                "\n                    ワンタッチパスIDの解除が完了しました。\n                "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isEmailSetting
                          ? _c("p", [
                              _vm._v("\n                    メール設定の変更"),
                              _c("br"),
                              _vm._v(
                                "\n                    が完了しました。\n                "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _vm._t("back-service-button"),
                    ],
                    2
                  ),
            ],
            2
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }